'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var style = {
  display: 'block',
  width: '100%',
  boxSizing: 'border-box'
};

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.InputText',

  propTypes: {
    value: _react.PropTypes.string.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },

  handleChange: function handleChange(e) {
    this.props.onChange(e.target.value);
  },

  render: function render() {
    return _react2['default'].createElement('input', {
      type: 'text',
      style: style,
      value: this.props.value,
      onChange: this.handleChange
    });
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/InputText.js
// module id = 967
// module chunks = 0